// extracted by mini-css-extract-plugin
export default {"mainContainer":"CardsContainer_mainContainer__dh8Oy","cardsContainer":"CardsContainer_cardsContainer__Q9jH7","noResults":"CardsContainer_noResults__385Ha"};